import { Command } from '#~/command/index.js';
import { PostHogFeatureFlag, PostHogManager } from '#~/posthog/index.js';
import { Protocol } from '@studio/models/control';
import deepFreeze from 'deep-freeze';
import { Tool } from './types.js';

/** Language constants. */
export const Lang = Object.freeze({
  protocol: {
    [Protocol.ONVIF]: 'ONVIF',
    [Protocol.VISCA_IP]: 'VISCA over IP',
    [Protocol.VISCA_SERIAL]: 'VISCA over Serial',
    [Protocol.HTTP]: 'HTTP'
    // [Protocol.SRT]: 'SRT'
  } satisfies Record<Protocol, string>
});

/** @internal */
export const PrefKeys = Object.freeze({
  gridLines: 'control.grid-lines.selected',
  tool: 'control.tool.selected',
  toolVariant: 'control.tool-variant.selected'
});

/** Tool manifest. */
export const Tools = async (): Promise<ToolsMap> => <ToolsMap>(<any>deepFreeze({
    [Tool.Zoom]: {
      command: Command.TOOL_ZOOM,
      icon: 'pointer',
      order: -1,
      options: [],
      hidden: false
    },
    [Tool.Center]: {
      command: Command.TOOL_CENTER,
      icon: 'click-center',
      order: 0,
      options: [
        {
          command: Command.TOOL_CENTER,
          icon: 'click-center',
          label: 'Click to Center'
        },
        {
          command: Command.TOOL_CINE_CENTER,
          icon: 'tracking',
          label: 'Cine Center'
        }
      ],
      hidden: false
    },
    [Tool.FastFrame]: {
      command: Command.TOOL_FAST_FRAME,
      icon: 'fast-frame',
      order: 1,
      options: [
        {
          command: Command.TOOL_FAST_FRAME,
          icon: 'fast-frame',
          label: 'Fast Frame'
        },
        {
          command: Command.TOOL_CINE_FRAME,
          icon: 'cine-frame',
          label: 'Cine Frame'
        }
      ],
      hidden: false
    },
    [Tool.Joystick]: {
      command: Command.TOOL_JOYSTICK,
      icon: 'joystick',
      order: 2,
      options: [],
      hidden: false
    },
    [Tool.Tracking]: {
      command: Command.TOOL_TRACKING,
      icon: 'auto-tracking',
      order: 4,
      options: [],
      hidden: !(await PostHogManager.getInstance().getFeatureFlag(PostHogFeatureFlag.AUTOTRACKING, {
        defaultValue: false
      }))
    }
  }));

export type ToolsMap = Record<
  Tool,
  {
    command: Command;
    icon: string;
    options: {
      command: Command;
      icon: string;
      label: string;
    }[];
    order: number;
    hidden: boolean;
  }
>;
